module.exports = __webpack_public_path__ + "img/fli_logo_white.d7356df5.png";